// Generated by purs version 0.15.0
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Eq_Generic from "../Data.Eq.Generic/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_Map_Internal from "../Data.Map.Internal/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Money_Rounded from "../Data.Money.Rounded/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Numeric from "../Data.Numeric/index.js";
import * as Data_OrderedMultiSet from "../Data.OrderedMultiSet/index.js";
import * as Data_Set_Serialized from "../Data.Set.Serialized/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Local from "../Data.Time.Local/index.js";
import * as Restaumatic_Calendar_Types_Availability from "../Restaumatic.Calendar.Types.Availability/index.js";
import * as Restaumatic_Menu_Types from "../Restaumatic.Menu.Types/index.js";
import * as Restaumatic_Menu_Types_Id from "../Restaumatic.Menu.Types.Id/index.js";
import * as Restaumatic_Menu_Types_SplitPizzaSettings from "../Restaumatic.Menu.Types.SplitPizzaSettings/index.js";
import * as Restaumatic_Menu_V2_Types_MenuCatalogue from "../Restaumatic.Menu.V2.Types.MenuCatalogue/index.js";
import * as Restaumatic_Promotions_Types from "../Restaumatic.Promotions.Types/index.js";
import * as Restaumatic_Promotions_Types_Id from "../Restaumatic.Promotions.Types.Id/index.js";
var AddedToppingsCalculator = /* #__PURE__ */ (function () {
    function AddedToppingsCalculator() {

    };
    AddedToppingsCalculator.value = new AddedToppingsCalculator();
    return AddedToppingsCalculator;
})();
var ToppingDifferenceCalculator = /* #__PURE__ */ (function () {
    function ToppingDifferenceCalculator() {

    };
    ToppingDifferenceCalculator.value = new ToppingDifferenceCalculator();
    return ToppingDifferenceCalculator;
})();
var ToppingDiffWithClampCalculator = /* #__PURE__ */ (function () {
    function ToppingDiffWithClampCalculator() {

    };
    ToppingDiffWithClampCalculator.value = new ToppingDiffWithClampCalculator();
    return ToppingDiffWithClampCalculator;
})();
var Topping = function (x) {
    return x;
};
var SizeDefinition = function (x) {
    return x;
};
var SideDish = function (x) {
    return x;
};
var Side = function (x) {
    return x;
};
var Pizza = function (x) {
    return x;
};
var Pan = function (x) {
    return x;
};
var Drink = function (x) {
    return x;
};
var DishGroup = function (x) {
    return x;
};
var Dish = function (x) {
    return x;
};
var Menu = function (x) {
    return x;
};
var promotions = function (v) {
    return v.promotions;
};
var overridePromotions = function (newPromos) {
    return function (v) {
        return {
            pizzas: v.pizzas,
            toppings: v.toppings,
            panTypes: v.panTypes,
            sizeNames: v.sizeNames,
            dishes: v.dishes,
            dishGroups: v.dishGroups,
            drinks: v.drinks,
            drinkSizeNames: v.drinkSizeNames,
            promotions: newPromos,
            toppingPriceCalculator: v.toppingPriceCalculator,
            timeZone: v.timeZone,
            enableCoupons: v.enableCoupons,
            enableFod: v.enableFod,
            enableMarketingConsents: v.enableMarketingConsents,
            splitPizzaSettings: v.splitPizzaSettings,
            customPizzaEnabled: v.customPizzaEnabled,
            catalogue: v.catalogue,
            imagePrefix: v.imagePrefix
        };
    };
};
var newtypeTopping = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSizeDef = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSideDish = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeSide = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePizza = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypePan = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeMenu = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDrink = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDishGroup = {
    Coercible0: function () {
        return undefined;
    }
};
var newtypeDish = {
    Coercible0: function () {
        return undefined;
    }
};
var modifyMenu = /* #__PURE__ */ Data_Newtype.over()()(Menu);
var isMainDish = function (v) {
    return Data_Maybe.isJust(v.dishGroupId);
};
var hasFieldMenu = function (dictHasField) {
    return dictHasField;
};
var genericToppingPriceCalculator = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return AddedToppingsCalculator.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return ToppingDifferenceCalculator.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inr) {
            return ToppingDiffWithClampCalculator.value;
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Menu (line 121, column 1 - line 121, column 82): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof AddedToppingsCalculator) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof ToppingDifferenceCalculator) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof ToppingDiffWithClampCalculator) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value));
        };
        throw new Error("Failed pattern match at Restaumatic.Menu.Menu (line 121, column 1 - line 121, column 82): " + [ x.constructor.name ]);
    }
};
var showToppingPriceCalculator = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericToppingPriceCalculator)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "AddedToppingsCalculator";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ToppingDifferenceCalculator";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments)({
        reflectSymbol: function () {
            return "ToppingDiffWithClampCalculator";
        }
    }))))
};
var genericTopping = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showTopping = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericTopping)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "category";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "iconUri";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "isBaseTopping";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "maxQuantity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "minQuantity";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPizzaSize)(Data_Money_Rounded.showMoney)))(Data_Show.showString))(Data_Show.showInt))(Data_Show.showInt))(Data_Show.showBoolean))(Restaumatic_Menu_Types_Id.showToppingId))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Topping";
        }
    }))
};
var genericSizeDef = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSizeDef = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSizeDef)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "cm";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Restaumatic_Menu_Types_Id.showPizzaSize))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showInt)))))({
        reflectSymbol: function () {
            return "SizeDefinition";
        }
    }))
};
var genericSideDish = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSideDish = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSideDish)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Money_Rounded.showMoney))(Data_Show.showString))(Restaumatic_Menu_Types_Id.showDishId))))({
        reflectSymbol: function () {
            return "SideDish";
        }
    }))
};
var genericSide = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showSide = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericSide)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "maxSelectedDishes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showInt))(Restaumatic_Menu_Types_Id.showSideId))(/* #__PURE__ */ Data_Show.showArray(showSideDish)))))({
        reflectSymbol: function () {
            return "Side";
        }
    }))
};
var genericPizza = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPizza = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPizza)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "allowedInSplitPizzas";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "freeToppings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "index";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppingExchangeEnabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppings";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_OrderedMultiSet.showOrderedMultiSet(Restaumatic_Menu_Types_Id.showToppingId)))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPizzaSize)(Data_Money_Rounded.showMoney)))(Data_Show.showString))(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Menu_Types_Id.showPizzaId))(Data_Show.showInt))(Data_Show.showBoolean))(Data_Show.showBoolean))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "Pizza";
        }
    }))
};
var genericPan = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showPan = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericPan)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "type";
        }
    })(Data_Show.showRecordFieldsNil)(Restaumatic_Menu_Types_Id.showPanType))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPizzaSize)(Data_Money_Rounded.showMoney)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Pan";
        }
    }))
};
var genericMenu = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var genericDrink = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDrink = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDrink)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "index";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showDrinkSize)(Data_Money_Rounded.showMoney)))(Data_Show.showString))(Data_Show.showInt))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Menu_Types_Id.showDrinkId))(Data_Show.showBoolean))(Data_Show.showBoolean))))({
        reflectSymbol: function () {
            return "Drink";
        }
    }))
};
var genericDishGroup = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDishGroup = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDishGroup)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "availability";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "index";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Show.showRecordFieldsNil)(Data_Show.showString))(Data_Show.showInt))(Restaumatic_Menu_Types_Id.showDishGroupId))(/* #__PURE__ */ Data_Show.showArray(Restaumatic_Menu_Types_Id.showDishId)))(Restaumatic_Calendar_Types_Availability.showWeeklyAvailability))))({
        reflectSymbol: function () {
            return "DishGroup";
        }
    }))
};
var genericDish = {
    to: function (x) {
        return x;
    },
    from: function (x) {
        return x;
    }
};
var showDish = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericDish)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "description";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishGroupId";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "id";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "name";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "price";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sides";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Show.showArray(showSide)))(Data_Money_Rounded.showMoney))(Data_Show.showString))(/* #__PURE__ */ Data_Maybe.showMaybe(Data_Show.showString)))(Restaumatic_Menu_Types_Id.showDishId))(Data_Show.showBoolean))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Maybe.showMaybe(Restaumatic_Menu_Types_Id.showDishGroupId)))(Data_Show.showString))))({
        reflectSymbol: function () {
            return "Dish";
        }
    }))
};
var showMenu = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericMenu)(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ Data_Show.showRecord()()(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "catalogue";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "customPizzaEnabled";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishGroups";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "drinkSizeNames";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "drinks";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableCoupons";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableFod";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "enableMarketingConsents";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "imagePrefix";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "panTypes";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "pizzas";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "sizeNames";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "splitPizzaSettings";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "timeZone";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppingPriceCalculator";
        }
    })(/* #__PURE__ */ Data_Show.showRecordFieldsCons({
        reflectSymbol: function () {
            return "toppings";
        }
    })(Data_Show.showRecordFieldsNil)(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showToppingId)(showTopping)))(showToppingPriceCalculator))(Data_Time_Local.showTZLabel))(Restaumatic_Menu_Types_SplitPizzaSettings.showSplitPizzaSettings))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPizzaSize)(showSizeDef)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Promotions_Types_Id.showPromotionId)(Restaumatic_Promotions_Types.showPromotion)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPizzaId)(showPizza)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showPanType)(showPan)))(Data_Show.showString))(Data_Show.showBoolean))(Data_Show.showBoolean))(Data_Show.showBoolean))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showDrinkId)(showDrink)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showDrinkSize)(Data_Show.showString)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showDishId)(showDish)))(/* #__PURE__ */ Data_Map_Internal.showMap(Restaumatic_Menu_Types_Id.showDishGroupId)(showDishGroup)))(Data_Show.showBoolean))(Restaumatic_Menu_V2_Types_MenuCatalogue.showMenuCatalogue))))({
        reflectSymbol: function () {
            return "Menu";
        }
    }))
};
var eqToppingPriceCalculator = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericToppingPriceCalculator)(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqSum(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(Data_Eq_Generic.genericEqNoArguments))))
};
var eqTopping = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericTopping)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPizzaSize)(Data_Money_Rounded.eqMoney)))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "minQuantity";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "maxQuantity";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "isBaseTopping";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqToppingId))()({
        reflectSymbol: function () {
            return "iconUri";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "category";
        }
    })(Data_Eq.eqString)))))
};
var eqSizeDef = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSizeDef)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaSize))()({
        reflectSymbol: function () {
            return "enabled";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "cm";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqInt))))))
};
var eqSideDish = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSideDish)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.eqMoney))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDishId)))))
};
var eqSide = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericSide)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "maxSelectedDishes";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqSideId))()({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(eqSideDish))))))
};
var eqPizza = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPizza)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Data_OrderedMultiSet.eqOrderedMultiSet(Restaumatic_Menu_Types_Id.eqToppingId)))()({
        reflectSymbol: function () {
            return "toppingExchangeEnabled";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPizzaSize)(Data_Money_Rounded.eqMoney)))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "index";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqPizzaId))()({
        reflectSymbol: function () {
            return "freeToppings";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enabled";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "allowedInSplitPizzas";
        }
    })(Data_Eq.eqBoolean)))))
};
var eqPan = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericPan)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "type";
        }
    })(Restaumatic_Menu_Types_Id.eqPanType))()({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPizzaSize)(Data_Money_Rounded.eqMoney)))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString)))))
};
var eqDrink = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDrink)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "priceBySize";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqDrinkSize)(Data_Money_Rounded.eqMoney)))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "index";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDrinkId))()({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enabled";
        }
    })(Data_Eq.eqBoolean)))))
};
var eqDishGroup = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDishGroup)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "index";
        }
    })(Data_Eq.eqInt))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDishGroupId))()({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(Restaumatic_Menu_Types_Id.eqDishId)))()({
        reflectSymbol: function () {
            return "availability";
        }
    })(Restaumatic_Calendar_Types_Availability.eqWeeklyAvailability)))))
};
var eqDish = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericDish)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "sides";
        }
    })(/* #__PURE__ */ Data_Eq.eqArray(eqSide)))()({
        reflectSymbol: function () {
            return "price";
        }
    })(Data_Money_Rounded.eqMoney))()({
        reflectSymbol: function () {
            return "name";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "image";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "id";
        }
    })(Restaumatic_Menu_Types_Id.eqDishId))()({
        reflectSymbol: function () {
            return "enabledInRos";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enabled";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "dishGroupId";
        }
    })(/* #__PURE__ */ Data_Maybe.eqMaybe(Restaumatic_Menu_Types_Id.eqDishGroupId)))()({
        reflectSymbol: function () {
            return "description";
        }
    })(Data_Eq.eqString)))))
};
var eqMenu = {
    eq: /* #__PURE__ */ Data_Eq_Generic.genericEq(genericMenu)(/* #__PURE__ */ Data_Eq_Generic.genericEqConstructor(/* #__PURE__ */ Data_Eq_Generic.genericEqArgument(/* #__PURE__ */ Data_Eq.eqRec()(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(/* #__PURE__ */ Data_Eq.eqRowCons(Data_Eq.eqRowNil)()({
        reflectSymbol: function () {
            return "toppings";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqToppingId)(eqTopping)))()({
        reflectSymbol: function () {
            return "toppingPriceCalculator";
        }
    })(eqToppingPriceCalculator))()({
        reflectSymbol: function () {
            return "timeZone";
        }
    })(Data_Time_Local.eqTZLabel))()({
        reflectSymbol: function () {
            return "splitPizzaSettings";
        }
    })(Restaumatic_Menu_Types_SplitPizzaSettings.eqSplitPizzaSettings))()({
        reflectSymbol: function () {
            return "sizeNames";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPizzaSize)(eqSizeDef)))()({
        reflectSymbol: function () {
            return "promotions";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Promotions_Types_Id.eqPromotionId)(Restaumatic_Promotions_Types.eqPromotion)))()({
        reflectSymbol: function () {
            return "pizzas";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPizzaId)(eqPizza)))()({
        reflectSymbol: function () {
            return "panTypes";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqPanType)(eqPan)))()({
        reflectSymbol: function () {
            return "imagePrefix";
        }
    })(Data_Eq.eqString))()({
        reflectSymbol: function () {
            return "enableMarketingConsents";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enableFod";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "enableCoupons";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "drinks";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqDrinkId)(eqDrink)))()({
        reflectSymbol: function () {
            return "drinkSizeNames";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqDrinkSize)(Data_Eq.eqString)))()({
        reflectSymbol: function () {
            return "dishes";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqDishId)(eqDish)))()({
        reflectSymbol: function () {
            return "dishGroups";
        }
    })(/* #__PURE__ */ Data_Map_Internal.eqMap(Restaumatic_Menu_Types_Id.eqDishGroupId)(eqDishGroup)))()({
        reflectSymbol: function () {
            return "customPizzaEnabled";
        }
    })(Data_Eq.eqBoolean))()({
        reflectSymbol: function () {
            return "catalogue";
        }
    })(Restaumatic_Menu_V2_Types_MenuCatalogue.eqMenuCatalogue)))))
};
var emptyMenu = /* #__PURE__ */ (function () {
    return {
        pizzas: Data_Map_Internal.empty,
        toppings: Data_Map_Internal.empty,
        panTypes: Data_Map_Internal.empty,
        sizeNames: Data_Map_Internal.empty,
        dishes: Data_Map_Internal.empty,
        dishGroups: Data_Map_Internal.empty,
        drinks: Data_Map_Internal.empty,
        drinkSizeNames: Data_Map_Internal.empty,
        toppingPriceCalculator: AddedToppingsCalculator.value,
        promotions: Data_Map_Internal.empty,
        timeZone: Data_Time_Local.utc,
        enableCoupons: false,
        enableFod: false,
        enableMarketingConsents: false,
        splitPizzaSettings: {
            basePrice: Restaumatic_Menu_Types_SplitPizzaSettings.MostExpensive.value,
            extraCharge: Data_Numeric.zero(Data_Money_Rounded.additiveMoney),
            maxSplits: 1,
            sizes: Data_Monoid.mempty(Data_Set_Serialized.monoidSet(Restaumatic_Menu_Types.ordPizzaSize)),
            enableToppingExchange: true
        },
        customPizzaEnabled: false,
        catalogue: {
            menus: Data_Newtype.wrap()(Data_Map_Internal.empty),
            products: Data_Newtype.wrap()(Data_Map_Internal.empty),
            combos: Data_Newtype.wrap()(Data_Map_Internal.empty),
            modifiers: Data_Newtype.wrap()(Data_Map_Internal.empty),
            sections: Data_Newtype.wrap()(Data_Map_Internal.empty),
            customParameters: Data_Newtype.wrap()(Data_Map_Internal.empty),
            categories: Data_Newtype.wrap()(Data_Map_Internal.empty),
            packagingContainers: Data_Newtype.wrap()(Data_Map_Internal.empty),
            availabilitySchedules: Data_Newtype.wrap()(Data_Map_Internal.empty),
            crossSellingLists: Data_Newtype.wrap()(Data_Map_Internal.empty),
            enabledMenuConsumers: Data_Newtype.wrap()(Data_Maybe.Nothing.value)
        },
        imagePrefix: "https://empty.example.com/"
    };
})();
var fromCatalogue = function (catalogue) {
    return modifyMenu(function (v) {
        return {
            pizzas: v.pizzas,
            toppings: v.toppings,
            panTypes: v.panTypes,
            sizeNames: v.sizeNames,
            dishes: v.dishes,
            dishGroups: v.dishGroups,
            drinks: v.drinks,
            drinkSizeNames: v.drinkSizeNames,
            promotions: v.promotions,
            toppingPriceCalculator: v.toppingPriceCalculator,
            timeZone: v.timeZone,
            enableCoupons: v.enableCoupons,
            enableFod: v.enableFod,
            enableMarketingConsents: v.enableMarketingConsents,
            splitPizzaSettings: v.splitPizzaSettings,
            customPizzaEnabled: v.customPizzaEnabled,
            catalogue: catalogue,
            imagePrefix: v.imagePrefix
        };
    })(emptyMenu);
};
export {
    Menu,
    modifyMenu,
    emptyMenu,
    fromCatalogue,
    Pizza,
    Topping,
    Pan,
    SizeDefinition,
    Side,
    Dish,
    DishGroup,
    SideDish,
    Drink,
    AddedToppingsCalculator,
    ToppingDifferenceCalculator,
    ToppingDiffWithClampCalculator,
    isMainDish,
    promotions,
    overridePromotions,
    hasFieldMenu,
    newtypeMenu,
    genericMenu,
    eqMenu,
    showMenu,
    genericToppingPriceCalculator,
    eqToppingPriceCalculator,
    showToppingPriceCalculator,
    newtypePizza,
    genericPizza,
    eqPizza,
    showPizza,
    newtypeTopping,
    genericTopping,
    eqTopping,
    showTopping,
    newtypePan,
    genericPan,
    eqPan,
    showPan,
    newtypeSizeDef,
    genericSizeDef,
    eqSizeDef,
    showSizeDef,
    newtypeDish,
    genericDish,
    eqDish,
    showDish,
    newtypeDishGroup,
    genericDishGroup,
    eqDishGroup,
    showDishGroup,
    newtypeSide,
    genericSide,
    eqSide,
    showSide,
    newtypeSideDish,
    genericSideDish,
    eqSideDish,
    showSideDish,
    newtypeDrink,
    genericDrink,
    eqDrink,
    showDrink
};
//# sourceMappingURL=index.js.map
